import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private _renderer2: Renderer2;
  constructor(private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document: Document
  ) { 
    this._renderer2 = rendererFactory.createRenderer(null, null);
  }

  setPageName(pageName: string) {
    let script = this._renderer2.createElement('script');
    script.text = `window.page_name= ${pageName}`;
    this._renderer2.appendChild(this._document.body, script);
  }

  setFirstFormInteraction(pageName: string) {
    let script = this._renderer2.createElement('script');
    script.text = `window.firstFormInteraction_${pageName} = true`;
    this._renderer2.appendChild(this._document.body, script);
  }

  setFormFinish(pageName: string) {
    let script = this._renderer2.createElement('script');
    script.text = `window.formFinish_${pageName} = true`;
    this._renderer2.appendChild(this._document.body, script);
  }

  setFormFinishIntent(pageName: string) {
    let script = this._renderer2.createElement('script');
    script.text = `window.formFinishIntent_${pageName} = true`;
    this._renderer2.appendChild(this._document.body, script);
  }

  setFormInteraction(eventName: string, eventAction: string) {
    let script = this._renderer2.createElement('script');
    /*
    script.text = `window.eventEffect = '${eventName}'`;
    this._renderer2.appendChild(this._document.body, script);
    script.text = `window.eventAction =  ${eventAction}`;
    this._renderer2.appendChild(this._document.body, script);
    */
    //script.text = `window.formInteractionTriggered =  ${true}`;
    
    script.text = `window.formInteractionValues = '${eventName},${eventAction},true'`;
    this._renderer2.appendChild(this._document.body, script);
  }


}


